import { Mutex } from 'lib/mutex';

import { BerthReservation } from 'data/models/BerthReservation';
import { PortCallRights } from 'server/enums/Rights';

import { ExistingReservationInPortOpsParams, InPortOps } from 'portcall/inportops/model';

export interface BerthAssignmentDetailsInPortOpsTabParams {
    BerthReservation : BerthReservation;
    PCRights : () => PortCallRights;
    /**
     * A mutex to prevent overlapping calls to save the given reservation or its child entities.
     */
     SaveMutex : Mutex;
}

export type BerthAssignmentDetailsInPortOpsTab = ReturnType<typeof BerthAssignmentDetailsInPortOpsTab>;
export function BerthAssignmentDetailsInPortOpsTab(
    existingInPortOpsModel : (params : ExistingReservationInPortOpsParams) => InPortOps,
    {
        BerthReservation,
        PCRights,
        SaveMutex
    } : BerthAssignmentDetailsInPortOpsTabParams
) {
    const
        InPortOps = existingInPortOpsModel({
            Reservation: BerthReservation,
            CanEdit: () => (PCRights() & PortCallRights.Edit) !== 0,
            SaveMutex
        }),
        Loading = () => InPortOps.IsSaving();

    return { InPortOps, Loading };
}



// WEBPACK FOOTER //
// ./apps/portcall/berthassignmentdetails/inportops.ts